/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LaborActivityDto } from '../../models/labor-activity-dto';

export interface GetLaborActivity$Params {
  id: string;
}

export function getLaborActivity(http: HttpClient, rootUrl: string, params: GetLaborActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborActivityDto>> {
  const rb = new RequestBuilder(rootUrl, getLaborActivity.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LaborActivityDto>;
    })
  );
}

getLaborActivity.PATH = '/v0/laborActivities/{id}';
